import { useEffect, useLayoutEffect } from 'react';
import { IMenuItem, IMenuOption } from '../types';

export const handleUrlNavigation = (url: string, openInNewTab: boolean) => {
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};

// We assume an item is a leaf node if it has a URL or an onClick handler
export const itemIsLeafNode = (item?: IMenuItem | IMenuOption) => {
  return !!item?.url || !!item?.onClick;
};

export const itemHasSubmenuSections = (item?: IMenuItem | IMenuOption) => {
  return !!item?.submenuSections && item?.submenuSections?.length > 0;
};

// A menu item should fetch submenu sections if it is not a leaf node and has not fetched submenu sections yet
export const itemShouldFetchSubmenuSections = (item?: IMenuItem | IMenuOption) => {
  return !itemIsLeafNode(item) && item?.shouldFetchNestedMenuItems && !itemHasSubmenuSections(item);
};

// Determine if a menu option has any direct L2 submenu sections that also contain L3 submenu sections
export const itemHasNestedSubmenus = (item?: IMenuOption) => {
  if (itemHasSubmenuSections(item)) {
    return item!
      .submenuSections!.flatMap((section) => section.items)
      .some((i) => itemShouldFetchSubmenuSections(i) || itemHasSubmenuSections(i));
  }
  return false;
};

export const useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
